module.exports = __webpack_public_path__ + "static/ocOval-ede3e385b1341cc05a969646295a5229.png";